/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Coomponents
import Badge from 'shared/ui/components/Badge.vue';
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import DoubleStat from 'shared/ui/components/cards/DoubleStat.vue';

const __vue_script__ = {
    name: 'PaxRequestActions',

    components: { Badge, DoubleStat },

    extends: BaseControl,

    props: {
        edit: {
            type: Boolean,
            default: false
        },

        model: {
            type: Object,
            required: true
        },

        value: {
            type: [Array, String],
            default: () => []
        }
    },

    data() {
        return {
            lang: 'en',
            result: null,
            pax: null,
            paxUrl: null,
            legalDocs: [],
            submitting: false
        };
    },

    created() {
        if (this.event.languages?.length) {
            this.lang = this.event.languages[0];
        }
        this.init();
    },

    methods: {
        init() {
            this.getPax();
            this.getLegalDocs();
        },

        approve() {
            this.updateStatus('approve');
        },

        deny() {
            this.updateStatus('deny');
        },

        async updateStatus(status) {
            try {
                if (this.submitting) {
                    return;
                }

                this.submitting = true;
                this.result = await this.$services.pax.setPaxRequestStatus(this.event._id, [this.model._id], status);
                const tKey = status === 'approve' ? 'registration.activation.request_approved' : 'registration.activation.request_denied';
                const action = this.$t(tKey).toString();

                setTimeout(() => {
                    this.$emit('reload');
                    this.$notify({
                        group: 'flashes',
                        text: this.$i18n.t('registration.activation.request_status_changed_successfully', [action]).toString(),
                        type: 'success',
                        duration: 5000
                    });
                    this.submitting = false;
                }, 1000);

            } catch (error) {
                console.error('[PaxRequestActions] Error approving request', error);
                this.$notify({
                    group: 'flashes',
                    title: this.$t('general.error_occurred'),
                    text: this.$i18n.t('registration.activation.request_status_change_failed').toString(),
                    type: 'error'
                });
                this.submitting = false;
            }
        },

        async getPax() {
            try {
                if (!this.model.activated_pid) {
                    return;
                }

                this.pax = await this.$services.pax.getPax(this.event._id, this.model.activated_pid);
                const usersModule = this.$services.blueprint.getModuleByName('participants');
                this.paxUrl = this.$utils.modules.getRouteHref(usersModule, 'view', {
                    _id: this.pax._id,
                    eventId: this.event._id
                });
            } catch (error) {
                console.error('[PaxRequestActions] Error getting pax', error);
            }
        },

        async getLegalDocs() {
            try {
                const legalDocs = [];
                for (const legal of this.model.accepted_legal_documents) {
                    const legalDoc = await this.$services.legal.getLegalDocument(legal);
                    const legalUrl = this.$services.legal.getDocumentPreviewUrl(legal);

                    legalDocs.push({
                        id: legal,
                        doc: legalDoc,
                        url: legalUrl
                    });
                }

                this.legalDocs = legalDocs;
            } catch (error) {
                console.error('[PaxRequestActions] Error getting legal docs', error);
            }
        },

        getDocName(doc) {
            const firstLang = Object.keys(doc.title)[0];
            return doc.title[this.lang] || doc.title.en || doc.title[firstLang];
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pax-request-actions boxed-content" }, [
    _c(
      "section",
      { staticClass: "details" },
      [
        _vm.model.accepted_legal_documents.length
          ? [
              _c("h5", [
                _vm._v(
                  _vm._s(
                    _vm.$t("registration.activation.accepted_legal_documents")
                  )
                ),
              ]),
              _c(
                "ul",
                _vm._l(_vm.legalDocs, function (legal) {
                  return _c("li", { key: legal.id }, [
                    _c("strong", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: legal.url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                          },
                        },
                        [_vm._v(_vm._s(_vm.getDocName(legal.doc)))]
                      ),
                    ]),
                  ])
                }),
                0
              ),
            ]
          : _vm._e(),
        _vm.model.fp_status === "denied"
          ? [
              _c(
                "i18n",
                {
                  attrs: {
                    tag: "p",
                    path: "registration.activation.request_status_changed_at",
                  },
                },
                [
                  _c("badge", { staticClass: "badge-danger" }, [
                    _vm._v(
                      _vm._s(_vm.$t("registration.activation.request_denied"))
                    ),
                  ]),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.$utils.time.tsToFormat(_vm.model.denied_at, "LLLL")
                      )
                    ),
                  ]),
                ],
                1
              ),
            ]
          : _vm._e(),
        _vm.model.fp_status === "consumed"
          ? [
              _c(
                "i18n",
                {
                  attrs: {
                    tag: "p",
                    path: "registration.activation.request_status_changed_at",
                  },
                },
                [
                  _c("badge", { staticClass: "badge-success" }, [
                    _vm._v(
                      _vm._s(_vm.$t("registration.activation.request_approved"))
                    ),
                  ]),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.$utils.time.tsToFormat(
                          _vm.model.account_created_at,
                          "LLLL"
                        )
                      )
                    ),
                  ]),
                ],
                1
              ),
            ]
          : _vm._e(),
        _vm.pax
          ? [
              _c(
                "i18n",
                {
                  attrs: {
                    tag: "p",
                    path: "registration.activation.created_pax",
                  },
                },
                [
                  _c("strong", [
                    _c("a", { attrs: { href: _vm.paxUrl } }, [
                      _vm._v(_vm._s(_vm.$utils.pax.getFullName(_vm.pax))),
                    ]),
                  ]),
                ]
              ),
            ]
          : _vm._e(),
        _vm.model.fp_status === "pending"
          ? [
              _c(
                "button",
                {
                  staticClass: "btn btn-success important",
                  attrs: { type: "button", disabled: _vm.submitting },
                  on: { click: _vm.approve },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("registration.activation.approve_request"))
                  ),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-danger important",
                  attrs: { type: "button", disabled: _vm.submitting },
                  on: { click: _vm.deny },
                },
                [_vm._v(_vm._s(_vm.$t("registration.activation.deny_request")))]
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/registrations/PaxRequestActions.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__